var CreditType = /* @__PURE__ */ ((CreditType2) => {
  CreditType2["RESIDUAL_PAYMENT"] = "residualPayment";
  CreditType2["ANNUITY"] = "annuity";
  return CreditType2;
})(CreditType || {});
var SortByPayment = /* @__PURE__ */ ((SortByPayment2) => {
  SortByPayment2["PAYMENT"] = "payment";
  SortByPayment2["_PAYMENT"] = "-payment";
  return SortByPayment2;
})(SortByPayment || {});
var SortByTitle = /* @__PURE__ */ ((SortByTitle2) => {
  SortByTitle2["NAME"] = "name";
  SortByTitle2["_NAME"] = "-name";
  return SortByTitle2;
})(SortByTitle || {});
var VehicleType = /* @__PURE__ */ ((VehicleType2) => {
  VehicleType2["NEW"] = "new";
  VehicleType2["USED"] = "used";
  return VehicleType2;
})(VehicleType || {});
export {
  CreditType,
  SortByPayment,
  SortByTitle,
  VehicleType
};
